import { render, staticRenderFns } from "./SymbolProxySettings.vue?vue&type=template&id=4958b661&"
import script from "./SymbolProxySettings.vue?vue&type=script&lang=js&"
export * from "./SymbolProxySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports